import * as React from "react";
var stage = global.UI_ENV !== "production" ? global.UI_ENV || "local development" : "";
var styles = {
    position: "absolute",
    bottom: "0.5rem",
    left: "2rem",
    color: "var(--whale-light)",
    fontSize: "1rem",
    zIndex: 1501,
};
export var Stage = function () {
    return React.createElement("div", { style: styles }, stage);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJTdGFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFPL0IsSUFBTSxLQUFLLEdBQ1QsTUFBTSxDQUFDLE1BQU0sS0FBSyxZQUFZLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLElBQUksbUJBQW1CLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztBQUM3RSxJQUFNLE1BQU0sR0FBd0I7SUFDbEMsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsSUFBSSxFQUFFLE1BQU07SUFDWixLQUFLLEVBQUUsb0JBQW9CO0lBQzNCLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLE1BQU0sRUFBRSxJQUFJO0NBQ2IsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLEtBQUssR0FBRztJQUNuQixPQUFPLDZCQUFLLEtBQUssRUFBRSxNQUFNLElBQUcsS0FBSyxDQUFPLENBQUM7QUFDM0MsQ0FBQyxDQUFDIn0=